import React, { Fragment } from 'react';
import { Box, Checkbox, FormControlLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import { IGroupedDataFilters } from './types';
import { toggleArrayValue, toggleGroupByKey } from '../utils';
import { FilterHeader } from './FilterHeader';
import { useTranslation } from 'react-i18next';
import { CapitalizeNames } from 'src/utils/capitalize';

const useStyles = makeStyles((theme) => ({
    icon: {
        color: theme.palette.primary.main,
        height: 24,
        width: 24,
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.75),
    },
    checkbox: {
        padding: theme.spacing(0.5),
        '& .MuiSvgIcon-root path': {
            color: theme.palette.secondary.main,
        },
    },
    controlLabel: {
        textTransform: 'capitalize',
    },
}));

export const GroupedDataFilters = ({
    type,
    categories,
    currents,
    setCurrents,
    groupedData,
    translationKey,
    singleItem,
}: IGroupedDataFilters) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Box className={classes.content}>
            {categories.map((category) => (
                <Fragment key={category}>
                    <FilterHeader
                        title={
                            translationKey
                                ? t(`${translationKey}.${category}`)
                                : category
                        }
                        singleItem={singleItem}
                        handleSelectAll={() =>
                            toggleGroupByKey({
                                category,
                                key: type,
                                group: groupedData[category],
                                currents,
                                setCurrents,
                            })
                        }
                    />
                    {groupedData[category].map(
                        (item: { _id: string; name: string }) => (
                            <FormControlLabel
                                className={classes.controlLabel}
                                key={item._id}
                                control={
                                    <Checkbox
                                        checked={
                                            Array.isArray(currents[type])
                                                ? currents[type].includes(
                                                      `[${category}]${item._id}`
                                                  )
                                                : false
                                        }
                                        onChange={() =>
                                            toggleArrayValue({
                                                key: type,
                                                value: `[${category}]${item._id}`,
                                                currents,
                                                setCurrents,
                                                singleItem,
                                            })
                                        }
                                        className={classes.checkbox}
                                    />
                                }
                                label={
                                    translationKey
                                        ? t(`${translationKey}.${item.name}`)
                                        : CapitalizeNames(item.name)
                                }
                            />
                        )
                    )}
                </Fragment>
            ))}
        </Box>
    );
};
